const api = "http://catastro.barranquilla.gov.co:8080/sky/servicon";
export default api;